import React, { useEffect, useState } from 'react';
const NAMES = ['María García', 'Carlos López', 'Ana Martínez', 'Pedro Sánchez', 'Laura Fernández', 'Javier Rodríguez', 'Carmen Díaz', 'Diego Moreno', 'Sofía Ruiz', 'Miguel Torres', 'Isabel Navarro', 'Pablo Jiménez', 'Elena Romero', 'Andrés Gil', 'Lucía Serrano'];
const CITIES = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga', 'Bilbao', 'Murcia', 'Alicante', 'Córdoba', 'Granada', 'Salamanca', 'Santander', 'Pamplona', 'Toledo'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      const nextInterval = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showPopup, nextInterval);
    };
    const initialTimer = setTimeout(showPopup, 5000);
    return () => {
      clearTimeout(initialTimer);
    };
  }, []);
  return <div className={`fixed bottom-6 left-6 z-50 bg-[#FAF7F2] rounded-2xl shadow-xl border border-[#D4A853]/20 p-5 max-w-sm flex items-center space-x-4 transition-all duration-500 ease-out ${isVisible ? 'opacity-100 translate-x-0 translate-y-0' : 'opacity-0 -translate-x-24 translate-y-5 pointer-events-none'}`} data-id="element-435">
      <div className="bg-[#1B4332]/10 p-3 rounded-full flex-shrink-0" data-id="element-436">
        <span className="text-2xl text-[#1B4332]" data-id="element-437">🛒</span>
      </div>
      <div data-id="element-438">
        <p className="text-sm text-[#1B4332] font-medium leading-snug" data-id="element-439">
          <span className="font-bold" style={{
          fontFamily: "'Playfair Display', Georgia, serif"
        }} data-id="element-440">
            {currentData.name}
          </span>{' '}
          de {currentData.city} acaba de comprar el MegaPack
        </p>
        <p className="text-xs text-[#2D5016]/60 mt-1.5 font-medium" data-id="element-441">
          Hace unos instantes
        </p>
      </div>
    </div>;
}